import { Dispatch, MutableRefObject, SetStateAction } from 'react';
import { CategoryType } from 'src/graphql';
import type { DefaultFlowIntakeSnapshot } from './categoryDynamicFlow';
import {
  mergeCategoryWithDefaultFlowIntakeSnapshot,
  patchCustomQuestionFlowVisibleChannels,
  patchDefaultQuestionFlowVisibleChannels,
  readDefaultFlowIntakeSnapshot,
} from './categoryDynamicFlow';

export const TAB_DEFAULT = 0;
export const TAB_CUSTOM = 1;

export type CategoryBodyTabChangeContext = {
  isCurrentCategory: boolean;
  activeTab: number;
  dynamicQuestionsV1: boolean;
  hasActiveLinkedForm: boolean;
  categoryId: number;
  setActiveTab: Dispatch<SetStateAction<number>>;
  setCurrentCategory: Dispatch<SetStateAction<CategoryType | null>>;
  defaultFlowIntakeSnapshotsByCategoryIdRef: MutableRefObject<
    Map<number, DefaultFlowIntakeSnapshot>
  >;
  vaultTalkEnabled: boolean;
  slackEnabled: boolean;
  goTogetherEnabled: boolean;
};

export const createCategoryBodyHandleTabChange = (
  ctx: CategoryBodyTabChangeContext,
) => {
  const {
    isCurrentCategory,
    activeTab,
    dynamicQuestionsV1,
    hasActiveLinkedForm,
    categoryId,
    setActiveTab,
    setCurrentCategory,
    defaultFlowIntakeSnapshotsByCategoryIdRef,
    vaultTalkEnabled,
    slackEnabled,
    goTogetherEnabled,
  } = ctx;

  return (index: number) => {
    if (!isCurrentCategory) {
      return;
    }
    if (index === activeTab) {
      return;
    }
    if (index === TAB_CUSTOM && (!dynamicQuestionsV1 || hasActiveLinkedForm)) {
      return;
    }
    if (index === TAB_DEFAULT && hasActiveLinkedForm) {
      return;
    }
    setActiveTab(index);
    setCurrentCategory((prev) => {
      if (!prev || prev.id !== categoryId) {
        return prev;
      }
      if (index === TAB_CUSTOM) {
        defaultFlowIntakeSnapshotsByCategoryIdRef.current.set(
          prev.id,
          readDefaultFlowIntakeSnapshot(prev),
        );
        return {
          ...patchCustomQuestionFlowVisibleChannels(prev),
          isCustomQuestions: true,
        };
      }
      const stored = defaultFlowIntakeSnapshotsByCategoryIdRef.current.get(
        prev.id,
      );
      if (stored) {
        return {
          ...mergeCategoryWithDefaultFlowIntakeSnapshot(prev, stored),
          isCustomQuestions: false,
        };
      }
      return {
        ...patchDefaultQuestionFlowVisibleChannels(
          prev,
          vaultTalkEnabled,
          slackEnabled,
          goTogetherEnabled,
        ),
        isCustomQuestions: false,
      };
    });
  };
};
